import { ActivityTracker } from '@fluidx/telemetry';
import { isOdspResolvedUrl, safeLocalStorage } from '@fluidx/utilities';
const InformationProtectionCacheKey = 'MIPCache';
let informationProtectionCache;
function getCacheKey(resolvedUrl) {
    if (isOdspResolvedUrl(resolvedUrl)) {
        return InformationProtectionCacheKey + '_' + resolvedUrl.hashedDocumentId;
    }
    return undefined;
}
export function getInformationProtectionFromCache(resolvedUrl, mipLogger) {
    if (informationProtectionCache) {
        return informationProtectionCache;
    }
    const tracker = ActivityTracker.start('getInformationProtectionFromCache', mipLogger, {
        addUserTiming: true,
        isAPerformanceMetric: true
    });
    const localStorage = safeLocalStorage();
    const cacheKey = getCacheKey(resolvedUrl);
    if (!cacheKey || !localStorage) {
        tracker.setResult(false /*succeeded*/, { cacheKey: !!cacheKey, localStorage: !!localStorage });
        return;
    }
    let mipCache = undefined;
    try {
        const cachedDetails = localStorage.getItem(cacheKey);
        if (cachedDetails) {
            mipCache = JSON.parse(cachedDetails);
        }
        tracker.setResult(true /*succeeded*/, {
            isCached: !!mipCache,
            currentLabel: !!mipCache?.currentLabel,
            policySettings: !!mipCache?.policySettings,
            watermark: !!mipCache?.watermark,
            hasProtection: !!mipCache?.hasProtection
        });
        informationProtectionCache = mipCache;
        return informationProtectionCache;
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any
    -- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */
    }
    catch (error) {
        tracker.setResult(false /*succeeded*/);
    }
    return undefined;
}
export async function updateInformationProtectionInCache(resolvedUrl, informationProtectionService, mipLogger) {
    const tracker = ActivityTracker.start('updateInformationProtectionInCache', mipLogger);
    const localStorage = safeLocalStorage();
    const cacheKey = getCacheKey(resolvedUrl);
    if (!cacheKey || !localStorage) {
        tracker.setResult(false /*succeeded*/, { cacheKey: !!cacheKey, localStorage: !!localStorage });
        return;
    }
    const [currentLabel, policySettings, watermark, irmCapabilities, hasProtection] = await Promise.all([
        informationProtectionService.getCurrentLabel(resolvedUrl),
        informationProtectionService.getPolicySettings(),
        informationProtectionService.getWatermarkInformation(resolvedUrl),
        informationProtectionService.getIrmInformation(resolvedUrl),
        informationProtectionService.getHasProtection(resolvedUrl)
    ]);
    const newCache = { currentLabel, policySettings, watermark, irmCapabilities, hasProtection };
    try {
        localStorage.setItem(cacheKey, JSON.stringify(newCache));
        informationProtectionCache = newCache;
        tracker.setResult(true /*succeeded*/, {
            isCached: !!newCache,
            currentLabel: !!newCache.currentLabel,
            policySettings: !!newCache.policySettings,
            watermark: !!newCache.watermark,
            hasProtection: !!newCache.hasProtection
        });
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any
    -- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */
    }
    catch (error) {
        tracker.setResult(false /*succeeded*/);
    }
}
//# sourceMappingURL=InformationProtectionCacheUtilities.js.map